import { createAction, props } from '@ngrx/store';
import { UploadEntity } from '@dges/modules/storage/domain';

export const upload = createAction(
  '[Upload Page] upload',
  props<{ files: File[]; folderName: string }>(),
);

export const loadUploadSuccess = createAction(
  '[Upload/API] Load Upload Success',
  props<{ upload: UploadEntity[] }>(),
);

export const loadUploadFailure = createAction(
  '[Upload/API] Load Upload Failure',
  props<{ error: unknown }>(),
);

export const cleanUploads = createAction('[Upload Page] Init');
